/* Dreavaya collection (WS3): server-side sort and filter links that keep every other URL parameter (view, utm_*, click ids).
   Quick add, pocket bar, load more, card video and tape centring come from dv-catalog.js; the filter sheet is a shared
   dv-panel (open/close, Esc, scrim, focus return in dv-cart.js), with a small fallback here. Old #category hashes are ignored. */
(() => {
  const D = document;
  const own = (k) => k === 'sort_by' || k === 'page' || k === 'section_id' || k === 'view' || k.indexOf('filter.') === 0;
  // carry the visitor's other parameters (utm_*, ttclid, fbclid, …) onto a sort/filter URL
  const keep = (u) => { new URL(location.href).searchParams.forEach((v, k) => { if (!own(k) && !u.searchParams.has(k)) u.searchParams.append(k, v); }); return u; };
  function sortTo(s) {
    const u = new URL(location.href); u.hash = '';
    if (s) u.searchParams.set('sort_by', s); else u.searchParams.delete('sort_by');
    u.searchParams.delete('page'); u.searchParams.delete('section_id');
    location.href = u.toString();
  }
  D.addEventListener('change', (e) => { const s = e.target.closest && e.target.closest('[data-dv-sort]'); if (s) sortTo(s.value); });
  D.addEventListener('click', (e) => {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest('[data-dv-sort-link], .dv-coll__active, .dv-coll__fclear');
    if (!a) return;
    e.preventDefault();
    if (a.hasAttribute('data-dv-sort-link')) return sortTo(a.getAttribute('data-dv-sort-link'));
    location.href = keep(new URL(a.href, location.href)).toString();
  });
  D.addEventListener('submit', (e) => {
    const f = e.target.closest('.dv-coll__fform'); if (!f) return;
    new URL(location.href).searchParams.forEach((v, k) => {
      if (own(k) || f.querySelector('[name="' + CSS.escape(k) + '"]')) return;
      const i = D.createElement('input'); i.type = 'hidden'; i.name = k; i.value = v; f.appendChild(i);
    });
  });

  // filter sheet fallback: only when the shared panels of dv-cart.js are not on the page
  const shared = () => window.DV && DV.openPanel;
  let back = null;
  const sheet = () => D.getElementById('DvFilter');
  function show(on) {
    const p = sheet(); if (!p) return;
    p.classList.toggle('is-open', on); p.setAttribute('aria-hidden', String(!on));
    D.documentElement.classList.toggle('dv-lock', on);
    if (on) { back = D.activeElement; const f = p.querySelector('.dv-panel__sheet button, .dv-panel__sheet a'); if (f) setTimeout(() => f.focus(), 50); }
    else if (back) back.focus();
  }
  D.addEventListener('click', (e) => {
    if (shared()) return;
    if (e.target.closest('[data-dv-open="DvFilter"]')) { e.preventDefault(); show(true); }
    else if (e.target.closest('#DvFilter [data-dv-close]')) { e.preventDefault(); show(false); }
  });
  D.addEventListener('keydown', (e) => { const p = sheet(); if (e.key === 'Escape' && !shared() && p && p.classList.contains('is-open')) show(false); });
})();
